var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item.externally_managed)?_c('label',{class:_vm.$style.externallyManagedLabel},[_vm._v(" AD Integration: "),_c('div',{class:_vm.$style.iconContainer},[_c('i',{staticClass:"jc-directories-badge-bg"}),_c('i',{class:['jc-directories-badge-active-directory-fg', _vm.$style.foregroundIcon]})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }